import { http, cookieStorage, createStorage, fallback } from "wagmi"
import { createConfig } from "@privy-io/wagmi"
import {
  mainnet,
  polygon,
  sepolia,
  polygonMumbai,
  optimism,
  optimismGoerli,
  base,
  zora,
  zoraTestnet,
  baseSepolia,
  linea,
  lineaSepolia,
} from "wagmi/chains"
import { Chain, type Transport } from "viem"

import { isMaster } from "@/util/constants/server"

const isProd = isMaster || process.env.NEXT_PUBLIC_FORCE_PROD_CHAINS

// Define specific chain IDs for production and testing
type ProdChainIds =
  | typeof mainnet.id
  | typeof polygon.id
  | typeof optimism.id
  | typeof base.id
  | typeof zora.id
  | typeof linea.id
  | typeof baseSepolia.id
type TestChainIds =
  | typeof sepolia.id
  | typeof polygonMumbai.id
  | typeof optimismGoerli.id
  | typeof baseSepolia.id
  | typeof zoraTestnet.id
  | typeof lineaSepolia.id

const prodTransports: Record<ProdChainIds, Transport> = {
  [mainnet.id]: fallback([
    http(
      "https://eth-mainnet.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
    http("https://mainnet.infura.io/v3/84566032b8074828961a55373c793e52"),
  ]),
  [polygon.id]: fallback([
    http(
      "https://polygon-mainnet.infura.io/v3/84566032b8074828961a55373c793e52"
    ),
    http(
      "https://polygon-mainnet.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
  ]),
  [optimism.id]: fallback([
    http(
      "https://opt-mainnet.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
    http(
      "https://optimism-mainnet.infura.io/v3/84566032b8074828961a55373c793e52"
    ),
  ]),
  [base.id]: fallback([
    http(
      "https://base-mainnet.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
    http("https://base-mainnet.infura.io/v3/84566032b8074828961a55373c793e52"),
  ]),

  [zora.id]: fallback([
    http(
      "https://zora-mainnet.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
  ]),

  [linea.id]: fallback([
    http("https://linea-mainnet.infura.io/v3/976fdbdbd348401899327207e5d311f9"),
  ]),
  [baseSepolia.id]: fallback([
    http(
      "https://base-sepolia.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
    http("https://base-sepolia.infura.io/v3/976fdbdbd348401899327207e5d311f9"),
  ]),
}

const testTransports: Record<TestChainIds, Transport> = {
  [sepolia.id]: fallback([
    http("https://sepolia.infura.io/v3/84566032b8074828961a55373c793e52"),
    http(
      "https://eth-sepolia.g.alchemy.com/v2/h0Uc6vitnXs8a5DoS3EZm6SBbsplkUqj"
    ),
  ]),
  [polygonMumbai.id]: http(),
  [optimismGoerli.id]: http(),
  [baseSepolia.id]: http(),
  [zoraTestnet.id]: http(),
  [lineaSepolia.id]: http(),
}

const transports = isProd ? prodTransports : testTransports

type ChainType = readonly [Chain, ...Chain[]]

const chains: ChainType = isProd
  ? [mainnet, polygon, optimism, base, zora, linea, baseSepolia]
  : [
      sepolia,
      polygonMumbai,
      optimismGoerli,
      baseSepolia,
      zoraTestnet,
      lineaSepolia,
    ]

export function getConfig() {
  return createConfig({
    chains,
    transports,
    // connectors: [],

    ssr: true,
    storage: createStorage({
      storage: cookieStorage,
    }),
  })
}
